import {ReactNode} from 'react';
import ReactSelect from 'react-select';

/**
 * Filtre déroulant pour les en-têtes de tableaux.
 *
 * Reprend le rendu déjà utilisé dans MyBills, NewsPage et Services (ReactSelect
 * avec `classNamePrefix="filter-select"` et portail sur le body), factorisé ici
 * pour éviter de redéclarer `filterSelectStyles` dans chaque page.
 */

export interface FilterOption<T> {
  value: T;
  label: string;
}

const filterSelectStyles = {
  menuPortal: (base: Record<string, unknown>) => ({...base, zIndex: 9999}),
};

interface FilterSelectProps<T> {
  options: FilterOption<T>[];
  value: T;
  onChange: (value: T) => void;
  minWidth?: number;
  maxWidth?: number;
  /** Personnalise le rendu du libellé (option du menu + valeur sélectionnée), sans toucher à `options`. */
  formatOptionLabel?: (option: FilterOption<T>) => ReactNode;
}

const FilterSelect = <T,>({
  options,
  value,
  onChange,
  minWidth = 200,
  maxWidth = 260,
  formatOptionLabel,
}: FilterSelectProps<T>): JSX.Element => (
  <div style={{minWidth, maxWidth}}>
    <ReactSelect<FilterOption<T>>
      options={options}
      value={options.find((option) => option.value === value)}
      onChange={(option) => option && onChange(option.value)}
      isSearchable={false}
      classNamePrefix="filter-select"
      menuPortalTarget={document.body}
      styles={filterSelectStyles}
      formatOptionLabel={formatOptionLabel ? (option) => formatOptionLabel(option) : undefined}
    />
  </div>
);

export default FilterSelect;
